/**
 * @module types/settings/chartSwitch
 * @description 图表类型切换配置（存储字段名 `chart_switch`）
 */

import type { TChartType } from '@dbl/core/chart';

export interface IChartSwitchValue {
  show: boolean;
  chartTypes: TChartType[];
}

const CHART_SWITCH_EMPTY_TYPES: TChartType[] = Object.freeze(
  [],
) as TChartType[];

/**
 * chart_switch 缺省：关闭切换，chartTypes 为空（UI 隐式勾选当前图表）
 *
 * @stable 须与 STRUCTURED_SETTING_DEFAULTS.chart_switch 为同一引用语义
 */
export const CHART_SWITCH_DEFAULT: IChartSwitchValue = Object.freeze({
  show: false,
  chartTypes: CHART_SWITCH_EMPTY_TYPES,
}) as IChartSwitchValue;
